module.exports = __webpack_public_path__ + "img/victrix-cinture-2.e809ce13.jpg";